const DEBUGGING: boolean = process.env.NODE_ENV === 'development'

import * as telegram from './telegram'
import * as utils from './utils'
import { BaseObject, MongoObject } from './_baseClasses'

export class Subedition extends MongoObject {
  protected static collectionName: string = 'subeditions'           // IMPORTANT
  private static NODE_CACHE_TTL: number = 300

  public subeditionID: number = null             // numeric subeditionID used by flow
  public name: string = null

  // complex, class-based fields (require to be hydrated after loading from external sources like mongo or elastic)

  constructor(po?: object, subeditionID?: number, name?: string) {
    super()
    if (po) this.injectPlainObject(po)
    if (subeditionID !== null && subeditionID !== undefined) this.subeditionID = subeditionID
    if (name) this.name = name
    this.hydrate()
  }

  protected hydrate(): void {
    super.hydrate()
  }

  // when sending to client
  public makeSafeForClient(): Subedition {
    return this
  }

  public isSafe(): boolean {
    return true
  }

  public static getLongName(name: string): string {
    if (!name) return null
    let nameToUse: string = name

    if (name.toLocaleLowerCase() === 'diamond') nameToUse = 'Diamond 💎'
    if (name.toLocaleLowerCase() === 'ruby') nameToUse = 'Ruby 🔴'
    if (name.toLocaleLowerCase() === 'sapphire') nameToUse = 'Sapphire 🔵'
    if (name.toLocaleLowerCase() === 'emerald') nameToUse = 'Emerald 🟢'

    return nameToUse
  }

  public static getShortName(name: string): string {
    if (!name) return null
    let nameToUse: string = name

    if (name.toLocaleLowerCase() === 'diamond') nameToUse = '💎'
    if (name.toLocaleLowerCase() === 'ruby') nameToUse = '🔴'
    if (name.toLocaleLowerCase() === 'sapphire') nameToUse = '🔵'
    if (name.toLocaleLowerCase() === 'emerald') nameToUse = '🟢'

    return nameToUse
  }


}




(async () => {
})();
